
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#gst-tenants-aadvantagehotels-app-modules-hotel-assets-svg-amenities-gym_svg-a)","stroke":"#50657c","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M7.5 6H6a1.5 1.5 0 00-1.5 1.5v9A1.5 1.5 0 006 18h1.5A1.5 1.5 0 009 16.5v-9A1.5 1.5 0 007.5 6zm-3 9.002H2.25a.75.75 0 01-.75-.75v-4.5a.75.75 0 01.75-.75H4.5M18 6h-1.5A1.5 1.5 0 0015 7.5v9a1.5 1.5 0 001.5 1.5H18a1.5 1.5 0 001.5-1.5v-9A1.5 1.5 0 0018 6zm1.5 9.002h2.25a.75.75 0 00.75-.75v-4.5a.75.75 0 00-.75-.75H19.5M9 12h6m8 0h1M1 12H0"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"gst-tenants-aadvantagehotels-app-modules-hotel-assets-svg-amenities-gym_svg-a"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    